webpackJsonp([16],{

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Banner = function (_React$Component) {
  _inherits(Banner, _React$Component);

  function Banner(props) {
    _classCallCheck(this, Banner);

    var _this = _possibleConstructorReturn(this, (Banner.__proto__ || Object.getPrototypeOf(Banner)).call(this, props));

    _this.state = {
      isVisible: _this.props.isVisible
    };

    _this.closeBtn = null;
    if (_this.props.isCloseable) {
      _this.closeBtn = _react2.default.createElement(
        'button',
        {
          onClick: _this.props.buttonClick,
          style: {
            border: 'none',
            display: 'inline-block',
            verticalAlign: 'middle',
            textAlign: 'center',
            padding: 0,
            fontSize: _this.props.fontSize,
            color: _this.props.buttonColor
          }
        },
        'x'
      );
    }
    return _this;
  }

  _createClass(Banner, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.isVisible !== nextProps.isVisible) {
        this.setState({ isVisible: nextProps.isVisible });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.isVisible) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        {
          className: this.props.className,
          style: Object.assign({}, this.props.style, { width: '100%' })
        },
        this.props.children,
        this.closeBtn
      );
    }
  }]);

  return Banner;
}(_react2.default.Component);

exports.default = Banner;


Banner.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  isVisible: _propTypes2.default.bool,
  isCloseable: _propTypes2.default.bool,
  buttonClick: _propTypes2.default.func,
  fontSize: _propTypes2.default.number,
  buttonColor: _propTypes2.default.string,
  style: _propTypes2.default.shape()
};

Banner.defaultProps = {
  className: '',
  isVisible: true,
  isCloseable: true,
  buttonClick: null,
  fontSize: 14,
  buttonColor: '#000',
  style: null
};

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ReactivationBanner = __webpack_require__(135);

var _Modals = __webpack_require__(169);

window.BuilderReactivationBanner = _ReactivationBanner.BuilderReactivationBanner;
window.ReactivationOfferModal = _Modals.ReactivationOfferModal;

__webpack_require__(67);
__webpack_require__(134);
window.OfferManager = __webpack_require__(72);
window.SessionManager = __webpack_require__(154);
window.exportChart = function (asPng, trackCategory, trackAction) {
    // PDF exports are server side, so only check if we have credits (and don't debit) for those.
    var checkOnly = !asPng;
    var offerManager = new window.OfferManager();
    offerManager.requestExport(function () {
        Chart.save();
        if (asPng) {
            Chart.exportPNG();
        } else {
            Chart.exportPNGToPDF();
        }

        if (typeof FreemiumBox !== "undefined") {
            FreemiumBox.deductCredit();
        }
        _track(trackCategory, trackAction);
    }, "/new-account-for-doc?" + window.location.search.substr(1), checkOnly);
};

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BuilderReactivationBanner = __webpack_require__(240);

Object.defineProperty(exports, 'BuilderReactivationBanner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BuilderReactivationBanner).default;
  }
});

var _MembersAreaReactivationBanner = __webpack_require__(241);

Object.defineProperty(exports, 'MembersAreaReactivationBanner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MembersAreaReactivationBanner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExportProgressBarModal = __webpack_require__(351);

Object.defineProperty(exports, 'ExportProgressBarModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExportProgressBarModal).default;
  }
});

var _FreeWriteSignatureCancelSurveyModal = __webpack_require__(355);

Object.defineProperty(exports, 'FreeWriteSignatureCancelSurveyModalContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FreeWriteSignatureCancelSurveyModal).default;
  }
});

var _FreeWriteSignatureReminderModal = __webpack_require__(319);

Object.defineProperty(exports, 'FreeWriteSignatureReminderModalContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FreeWriteSignatureReminderModal).default;
  }
});

var _ModalConstants = __webpack_require__(20);

Object.defineProperty(exports, 'ModalTypeEnum', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalConstants).default;
  }
});

var _ReactivationOfferModal = __webpack_require__(352);

Object.defineProperty(exports, 'ReactivationOfferModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ReactivationOfferModal).default;
  }
});

var _UpdateSubscriptionProgressModal = __webpack_require__(353);

Object.defineProperty(exports, 'UpdateSubscriptionProgressModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UpdateSubscriptionProgressModal).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _Banner = __webpack_require__(103);

var _Banner2 = _interopRequireDefault(_Banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BuilderReactivationBanner = function BuilderReactivationBanner(_ref) {
  var builderType = _ref.builderType,
      isCancelled = _ref.isCancelled;

  var trackAndRedirect = function trackAndRedirect() {
    if (isCancelled) {
      window._track('Reactivate Banner', builderType + ' Builder');
      window.location.assign('/my-account?skip_start_reactivation=1');
    } else {
      window._track('Upgrade Banner', builderType + ' Builder');
      window.location.assign('/upgrade-freemium');
    }
  };

  return _react2.default.createElement(
    _Banner2.default,
    { isCloseable: false },
    _react2.default.createElement(
      'div',
      { className: 'builder-reactivation-banner' },
      _react2.default.createElement(
        'p',
        { className: 'free-downloads-text' },
        'Looks like you are out of free downloads, but not to worry!'
      ),
      _react2.default.createElement(
        'p',
        { className: 'discount-text' },
        'To download this document,',
        ' ',
        _react2.default.createElement(
          'a',
          { className: 'upgrade', onClick: trackAndRedirect },
          isCancelled ? 'REACTIVATE' : 'UPGRADE'
        ),
        ' ',
        isCancelled ? 'your' : 'to a',
        ' ',
        'paid plan today!'
      )
    )
  );
};

BuilderReactivationBanner.defaultProps = {
  isCancelled: false
};

BuilderReactivationBanner.propTypes = {
  builderType: _propTypes2.default.string.isRequired,
  isCancelled: _propTypes2.default.bool
};

exports.default = (0, _WithInit2.default)(BuilderReactivationBanner);

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _Banner = __webpack_require__(103);

var _Banner2 = _interopRequireDefault(_Banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MembersAreaReactivationBanner = function MembersAreaReactivationBanner(_ref) {
  var page = _ref.page;

  var trackAndRedirect = function trackAndRedirect() {
    window._track('Reactivate Banner', page);
    window.location.assign('/my-account?subscription_settings_scroll=1');
  };

  return _react2.default.createElement(
    _Banner2.default,
    {
      isCloseable: false
    },
    _react2.default.createElement(
      'div',
      { className: 'members-area-reactivation-banner' },
      _react2.default.createElement(
        'button',
        { onClick: trackAndRedirect },
        'Reactivate'
      ),
      '\xA0your account today to export your documents!'
    )
  );
};

MembersAreaReactivationBanner.propTypes = {
  page: _propTypes2.default.string.isRequired
};

exports.default = (0, _WithInit2.default)(MembersAreaReactivationBanner);

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportProgressBarWithRedux = exports.ExportProgressBar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _Animation = __webpack_require__(323);

var _ProgressBar = __webpack_require__(99);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _ProgressBarStep = __webpack_require__(348);

var _ProgressBarStep2 = _interopRequireDefault(_ProgressBarStep);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportProgressBar = exports.ExportProgressBar = function (_React$Component) {
  _inherits(ExportProgressBar, _React$Component);

  function ExportProgressBar(props) {
    _classCallCheck(this, ExportProgressBar);

    var _this = _possibleConstructorReturn(this, (ExportProgressBar.__proto__ || Object.getPrototypeOf(ExportProgressBar)).call(this, props));

    var defaultCallback = function defaultCallback() {
      window.location.assign(props.href);
    };

    _this.state = {
      progressBarStepAnimationTime: 3500,
      callbackToUse: props.callback || defaultCallback
    };
    return _this;
  }

  _createClass(ExportProgressBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var userId = window.COOKIE.get('userid');
      if (userId) {
        this.state.callbackToUse();
        return;
      }

      this.props.startProgressBarAnimation(4, this.state.progressBarStepAnimationTime);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var callbackToUse = this.state.callbackToUse;
      if (this.props.progressBarAnimation.finished) {
        setTimeout(function () {
          callbackToUse();
        }, 100);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var animationStarted = this.props.progressBarAnimation.started;
      return _react2.default.createElement(
        'div',
        { className: 'export-progress-bar' },
        _react2.default.createElement(
          'div',
          { className: 'export-progress-bar-content' },
          _react2.default.createElement(
            'div',
            { className: 'progress-header' },
            'Preparing Document...'
          ),
          _react2.default.createElement(_ProgressBar2.default, {
            progressBarClassName: 'progress-bar',
            progressClassName: 'progress-bar-progress',
            step: this.props.progressBarAnimation.step,
            totalSteps: this.props.progressBarAnimation.totalSteps
          }),
          _react2.default.createElement(
            'ul',
            { className: 'spinner-wrapper' },
            _react2.default.createElement(_ProgressBarStep2.default, {
              started: animationStarted && this.props.progressBarAnimation.step >= 0,
              completed: this.props.progressBarAnimation.step > 0,
              animationTime: this.state.progressBarStepAnimationTime,
              text: 'Proofreading clauses'
            }),
            _react2.default.createElement(_ProgressBarStep2.default, {
              started: animationStarted && this.props.progressBarAnimation.step >= 1,
              completed: this.props.progressBarAnimation.step > 1,
              animationTime: this.state.progressBarStepAnimationTime,
              text: 'Enabling electronic signatures'
            }),
            _react2.default.createElement(_ProgressBarStep2.default, {
              started: animationStarted && this.props.progressBarAnimation.step >= 2,
              completed: this.props.progressBarAnimation.step > 2,
              animationTime: this.state.progressBarStepAnimationTime,
              text: 'Preparing document in word and PDF formats'
            }),
            _react2.default.createElement(_ProgressBarStep2.default, {
              started: animationStarted && this.props.progressBarAnimation.step >= 3,
              completed: this.props.progressBarAnimation.finished,
              animationTime: this.state.progressBarStepAnimationTime,
              text: 'Eliminating spelling and grammar errors'
            })
          )
        )
      );
    }
  }]);

  return ExportProgressBar;
}(_react2.default.Component);

ExportProgressBar.propTypes = {
  callback: _propTypes2.default.func,
  href: _propTypes2.default.string.isRequired,
  progressBarAnimation: _propTypes2.default.shape({
    started: _propTypes2.default.bool,
    finished: _propTypes2.default.bool,
    step: _propTypes2.default.number,
    totalSteps: _propTypes2.default.number
  }).isRequired,
  startProgressBarAnimation: _propTypes2.default.func.isRequired
};

ExportProgressBar.defaultProps = {
  callback: null
};

var mapStateToProps = function mapStateToProps(_ref) {
  var AnimationReducer = _ref.AnimationReducer;
  return {
    progressBarAnimation: AnimationReducer[_Animation.AnimationConstants.PROGRESS_BAR_ANIMATION]
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_extends({}, _Animation.AnimationActions), dispatch);
};

var ExportProgressBarWithRedux = exports.ExportProgressBarWithRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(ExportProgressBar);

exports.default = (0, _WithInit2.default)(ExportProgressBarWithRedux, true);

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ModalConstants = __webpack_require__(20);

var _ModalConstants2 = _interopRequireDefault(_ModalConstants);

var _ConnectModal = __webpack_require__(34);

var _ConnectModal2 = _interopRequireDefault(_ConnectModal);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _SignatureReminderBodyContent = __webpack_require__(357);

var _SignatureReminderBodyContent2 = _interopRequireDefault(_SignatureReminderBodyContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FreeWriteSignatureReminderModalContainer = (0, _ConnectModal2.default)(_BaseModal2.default, 'signatureReminderModal', {
  modalType: _ModalConstants2.default.FREE_WRITE_SIGNATURE_REMINDER,
  bodyContent: _react2.default.createElement(_SignatureReminderBodyContent2.default, {
    modalType: _ModalConstants2.default.FREE_WRITE_SIGNATURE_REMINDER
  }),
  footerButtons: false,
  trackFreeWrite: true,
  ariaLabel: 'Signature Reminder Modal',
  includeHeaderCloseButton: false,
  preventClickingOutside: true
});

exports.default = FreeWriteSignatureReminderModalContainer;

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _ModalActions = __webpack_require__(82);

var ModalActions = _interopRequireWildcard(_ModalActions);

var _store = __webpack_require__(25);

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var connectModal = function connectModal(WrappedComponent, elmId) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var mapStateToProps = function mapStateToProps(state) {
    return {
      activeModal: state.ModalHandler.activeModal,
      finalStep: state.ModalHandler.finalStep,
      additionalData: state.ModalHandler.additionalData
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)(_extends({}, ModalActions), dispatch);
  };

  var ConnectedWrappedComponent = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);

  var ModalContainer = function (_React$Component) {
    _inherits(ModalContainer, _React$Component);

    function ModalContainer() {
      _classCallCheck(this, ModalContainer);

      return _possibleConstructorReturn(this, (ModalContainer.__proto__ || Object.getPrototypeOf(ModalContainer)).apply(this, arguments));
    }

    _createClass(ModalContainer, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            ConnectedWrappedComponent,
            this.props,
            this.props.children && this.props.children
          )
        );
      }
    }], [{
      key: 'init',
      value: function init(additionalData) {
        var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var elementId = id || elmId;
        var properties = Object.assign({}, props, additionalData);

        _reactDom2.default.render(_react2.default.createElement(
          ReactRedux.Provider,
          { store: _store2.default },
          _react2.default.createElement(ModalContainer, properties)
        ), document.getElementById(elementId));
      }
    }]);

    return ModalContainer;
  }(_react2.default.Component);

  ModalContainer.defaultProps = {
    children: null
  };

  ModalContainer.propTypes = {
    children: _propTypes2.default.node
  };

  return ModalContainer;
};

if (window.FormSwift && window.FormSwift.React) {
  var newActions = Object.assign({}, window.FormSwift.React.actions, ModalActions);
  window.FormSwift.React.actions = newActions;
} else {
  window.FormSwift = {
    React: {
      store: _store2.default,
      actions: ModalActions
    }
  };
}

exports.default = connectModal;

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _ProgressSpinner = __webpack_require__(349);

var _ProgressSpinner2 = _interopRequireDefault(_ProgressSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBarStep = function ProgressBarStep(props) {
  var spinnerItemClassName = (0, _classnames2.default)('spinner-item', {
    completed: props.completed
  });
  return _react2.default.createElement(
    'li',
    { className: spinnerItemClassName },
    props.completed && _react2.default.createElement(
      'div',
      {
        className: 'loading-complete-wrapper'
      },
      _react2.default.createElement('img', {
        alt: 'Done',
        className: 'progress-complete',
        src: '//cdn.smartresumewizard.com/images/icons/check-mark-2x.png'
      })
    ),
    !props.completed && _react2.default.createElement(_ProgressSpinner2.default, {
      started: props.started,
      animationTime: props.animationTime
    }),
    _react2.default.createElement(
      'div',
      { className: 'progess-bar-step-text' },
      props.text
    )
  );
};

ProgressBarStep.propTypes = {
  animationTime: _propTypes2.default.number.isRequired,
  started: _propTypes2.default.bool,
  completed: _propTypes2.default.bool,
  text: _propTypes2.default.string
};

ProgressBarStep.defaultProps = {
  completed: false,
  started: false,
  text: ''
};

exports.default = ProgressBarStep;

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Migrated from progress-circle.js, which was based off of // spinner code from https://codepen.io/phantomesse/pen/uzeyC?q=loading+circle&limit=all&type=type-pen
var PROGRESS_SPOKE_COUNT = 8.0;
var SPOKE_WIDTH = 4;
var PROGRESS_SPOKE_DURATION = 500;
var PROGRESS_SPOKE_X_OFFSET = 0.75;
var PROGRESS_SPOKE_Y_OFFSET = 1.5;
var PROGRESS_SPOKE_CONTAINER_WIDTH = 25;

var ProgressSpinner = function ProgressSpinner(props) {
  if (!props.started) {
    return _react2.default.createElement('div', { className: 'loading-spinner' });
  }

  var delay = (props.animationTime - PROGRESS_SPOKE_DURATION) / PROGRESS_SPOKE_COUNT / 1000.0;
  var progressSpinner = [];

  for (var i = 0; i < PROGRESS_SPOKE_COUNT; i += 1) {
    var degreeTot = (PROGRESS_SPOKE_COUNT * 3 / 4 + i) * 360;
    var degree = degreeTot / PROGRESS_SPOKE_COUNT;
    var degreeRadians = degree * (Math.PI / 180);
    var radius = (PROGRESS_SPOKE_CONTAINER_WIDTH - SPOKE_WIDTH * 3) / 2;
    var x = Math.cos(degreeRadians) * radius + radius + SPOKE_WIDTH * PROGRESS_SPOKE_X_OFFSET;
    var y = Math.sin(degreeRadians) * radius + radius + SPOKE_WIDTH * PROGRESS_SPOKE_Y_OFFSET;

    var style = {
      width: SPOKE_WIDTH * 1.5 + 'px',
      height: SPOKE_WIDTH / 2 + 'px',
      top: y + 'px',
      left: x + 'px',
      transform: 'rotate(' + degree + 'deg)',
      animationDuration: PROGRESS_SPOKE_DURATION / 1000.0 + 's',
      animationDelay: delay * i + 's'
    };

    var spoke = _react2.default.createElement('div', {
      key: i,
      className: 'spoke',
      style: style
    });

    progressSpinner.push(spoke);
  }
  return _react2.default.createElement(
    'div',
    { className: 'loading-spinner' },
    progressSpinner
  );
};

ProgressSpinner.propTypes = {
  animationTime: _propTypes2.default.number.isRequired,
  started: _propTypes2.default.bool
};

ProgressSpinner.defaultProps = {
  completed: false,
  started: false
};

exports.default = ProgressSpinner;

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportProgressBarModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ExportProgressBar = __webpack_require__(318);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Export progress modal does not close, but `BaseModal` requires a `closeModal`
// method prop and calls it, which is why we have an empty method passed in
var ExportProgressBarModal = exports.ExportProgressBarModal = function ExportProgressBarModal(props) {
  return _react2.default.createElement(_BaseModal2.default, {
    modalType: 'export-progress-bar-modal',
    activeModal: 'export-progress-bar-modal',
    ariaHideApp: false,
    modalClass: 'progress-modal',
    closeModal: function closeModal() {},
    modalBodyClass: 'modal-content',
    bodyContent: _react2.default.createElement(_ExportProgressBar.ExportProgressBarWithRedux, { href: props.href, callback: props.callback })
  });
};

ExportProgressBarModal.propTypes = {
  href: _propTypes2.default.string.isRequired,
  callback: _propTypes2.default.func
};

ExportProgressBarModal.defaultProps = {
  callback: null
};

exports.default = (0, _WithInit2.default)(ExportProgressBarModal, true);

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactivationOfferModal = function ReactivationOfferModal(_ref) {
  var reactivationPage = _ref.reactivationPage;

  var trackAndRedirect = function trackAndRedirect() {
    window._track('Get Started | Reactivation Modal', reactivationPage);
    window.location.assign('/my-account?skip_start_reactivation=1');
  };

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'modal-header' },
      _react2.default.createElement(
        'button',
        { className: 'close', 'data-dismiss': 'modal' },
        'X'
      ),
      _react2.default.createElement(
        'h3',
        null,
        'This feature requires a paid subscription.'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal-body' },
      _react2.default.createElement(
        'p',
        { className: 'reactivate-yours' },
        'Reactivate yours now for $37 per month.'
      ),
      _react2.default.createElement(
        'p',
        { className: 'reactivation-seconds' },
        'It only takes a few seconds.'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal-footer' },
      _react2.default.createElement(
        'div',
        { className: 'buttons center' },
        _react2.default.createElement(
          'a',
          { className: 'btn btn-success btn-large', onClick: trackAndRedirect },
          'Get Started'
        )
      )
    )
  );
};

ReactivationOfferModal.propTypes = {
  reactivationPage: _propTypes2.default.string.isRequired
};

exports.default = (0, _WithInit2.default)(ReactivationOfferModal);

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _store = __webpack_require__(25);

var _store2 = _interopRequireDefault(_store);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _ConnectModal = __webpack_require__(34);

var _ConnectModal2 = _interopRequireDefault(_ConnectModal);

var _ModalConstants = __webpack_require__(20);

var _ModalConstants2 = _interopRequireDefault(_ModalConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpdateSubscriptionProgressModalWithRedux = (0, _ConnectModal2.default)(_BaseModal2.default);

var UpdateSubscriptionProgressModal = function (_React$Component) {
  _inherits(UpdateSubscriptionProgressModal, _React$Component);

  function UpdateSubscriptionProgressModal() {
    _classCallCheck(this, UpdateSubscriptionProgressModal);

    return _possibleConstructorReturn(this, (UpdateSubscriptionProgressModal.__proto__ || Object.getPrototypeOf(UpdateSubscriptionProgressModal)).apply(this, arguments));
  }

  _createClass(UpdateSubscriptionProgressModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(UpdateSubscriptionProgressModalWithRedux, {
        modalType: _ModalConstants2.default.UPDATE_SUBSCRIPTION_PROGRESS_READY,
        headerText: 'Updating Subscription...',
        bodyContent: _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'p',
            null,
            'Please wait, this could take up to 15 seconds.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Do not refresh'
            ),
            ' your browser'
          )
        ),
        footerContent: _react2.default.createElement('img', { alt: 'Loading', src: '//cdn.smartresumewizard.com/images/icons/loading_circle.gif' }),
        ariaLabel: 'Updating Subscription'
      });
    }
  }], [{
    key: 'init',
    value: function init(id, props) {
      _reactDom2.default.render(_react2.default.createElement(
        ReactRedux.Provider,
        { store: _store2.default },
        _react2.default.createElement(UpdateSubscriptionProgressModal, props)
      ), document.getElementById(id));
    }
  }]);

  return UpdateSubscriptionProgressModal;
}(_react2.default.Component);

exports.default = UpdateSubscriptionProgressModal;

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ModalConstants = __webpack_require__(20);

var _ModalConstants2 = _interopRequireDefault(_ModalConstants);

var _ConnectModal = __webpack_require__(34);

var _ConnectModal2 = _interopRequireDefault(_ConnectModal);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _SignatureCancelSurveyBodyContent = __webpack_require__(356);

var _SignatureCancelSurveyBodyContent2 = _interopRequireDefault(_SignatureCancelSurveyBodyContent);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _store = __webpack_require__(25);

var _store2 = _interopRequireDefault(_store);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FreeWriteSignatureCancelSurveyModalWithRedux = (0, _ConnectModal2.default)(_BaseModal2.default);

var FreeWriteSignatureCancelSurveyModalContainer = function (_React$Component) {
  _inherits(FreeWriteSignatureCancelSurveyModalContainer, _React$Component);

  function FreeWriteSignatureCancelSurveyModalContainer() {
    _classCallCheck(this, FreeWriteSignatureCancelSurveyModalContainer);

    return _possibleConstructorReturn(this, (FreeWriteSignatureCancelSurveyModalContainer.__proto__ || Object.getPrototypeOf(FreeWriteSignatureCancelSurveyModalContainer)).apply(this, arguments));
  }

  _createClass(FreeWriteSignatureCancelSurveyModalContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(FreeWriteSignatureCancelSurveyModalWithRedux, {
        modalType: _ModalConstants2.default.FREE_WRITE_CANCEL_SIGNATURE_SURVEY,
        includeHeaderCloseButton: true,
        bodyContent: _react2.default.createElement(_SignatureCancelSurveyBodyContent2.default, {
          modalType: _ModalConstants2.default.FREE_WRITE_CANCEL_SIGNATURE_SURVEY
        }),
        footerButtons: false,
        trackFreeWrite: true,
        ariaLabel: 'Cancel Signature Survey Request Modal'
      });
    }
  }], [{
    key: 'init',
    value: function init(id) {
      _reactDom2.default.render(_react2.default.createElement(
        ReactRedux.Provider,
        { store: _store2.default },
        _react2.default.createElement(FreeWriteSignatureCancelSurveyModalContainer, null)
      ), document.getElementById(id));
    }
  }]);

  return FreeWriteSignatureCancelSurveyModalContainer;
}(_react2.default.Component);

exports.default = FreeWriteSignatureCancelSurveyModalContainer;

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignatureCancelSurveyModalBodyContent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(83);

var _Button2 = _interopRequireDefault(_Button);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalActions = __webpack_require__(82);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeModal: _ModalActions.closeModal
  }, dispatch);
};

var SignatureCancelSurveyModalBodyContent = exports.SignatureCancelSurveyModalBodyContent = function (_React$Component) {
  _inherits(SignatureCancelSurveyModalBodyContent, _React$Component);

  function SignatureCancelSurveyModalBodyContent() {
    _classCallCheck(this, SignatureCancelSurveyModalBodyContent);

    var _this = _possibleConstructorReturn(this, (SignatureCancelSurveyModalBodyContent.__proto__ || Object.getPrototypeOf(SignatureCancelSurveyModalBodyContent)).call(this));

    _this.state = {
      response: null,
      cancelReason: '',
      selection: null
    };
    _this.onChange = _this.changeSelection.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.onChangeText = _this.changeText.bind(_this);
    return _this;
  }

  _createClass(SignatureCancelSurveyModalBodyContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window._track('Viewed Cancel Request Survey', 'My Documents');
    }
  }, {
    key: 'changeSelection',
    value: function changeSelection(e) {
      var cancelReason = e.target.value === 'Other' ? ' ' + this.state.cancelReason : '';
      this.setState({
        response: '' + e.target.value + cancelReason + ' | Cancel Request Survey',
        selection: e.target.value
      });
    }
  }, {
    key: 'changeText',
    value: function changeText(e) {
      this.setState({
        cancelReason: '' + e.target.value
      });

      if (this.state.selection === 'Other') {
        this.setState({
          response: this.state.selection + ' ' + e.target.value + ' | Cancel Request Survey'
        });
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      if (this.state.response) {
        this.props.closeModal(this.props.modalType);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cancel-sig-survey' },
        _react2.default.createElement(
          'h4',
          null,
          'Request Canceled. Do you mind sharing why you canceled your request?'
        ),
        _react2.default.createElement(
          'form',
          { id: 'cancelForm' },
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'cancelReason',
            value: 'Don\'t understand feature',
            id: 'understand',
            onChange: this.onChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'understand' },
            'I don\u2019t understand what this feature is.'
          ),
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'cancelReason',
            value: 'Still need to edit',
            id: 'edit',
            onChange: this.onChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'edit' },
            'I still need to edit my document.'
          ),
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'cancelReason',
            value: 'Only one signing',
            id: 'oneSigning',
            onChange: this.onChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'oneSigner' },
            'I am the only one signing this document and therefore do not need to send it to someone else.'
          ),
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'cancelReason',
            value: 'Don\'t need signature',
            id: 'noSignature',
            onChange: this.onChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'noSignature' },
            'I don\u2019t need a signature on this document.'
          ),
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'cancelReason',
            value: 'Other',
            id: 'other',
            onChange: this.onChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'other' },
            'Other ',
            _react2.default.createElement(
              'i',
              null,
              '(please explain)'
            ),
            ' '
          ),
          _react2.default.createElement('textarea', { name: 'cancelReason', id: 'otherReason', onChange: this.onChangeText })
        ),
        _react2.default.createElement(
          'div',
          { className: 'buttons' },
          _react2.default.createElement(_Button2.default, {
            buttonOnClick: this.closeModal,
            buttonText: 'Submit Answer',
            trackCategory: this.state.response,
            trackAction: 'My Documents',
            form: 'cancelForm',
            type: 'submit'
          })
        )
      );
    }
  }]);

  return SignatureCancelSurveyModalBodyContent;
}(_react2.default.Component);

SignatureCancelSurveyModalBodyContent.defaultProps = {
  modalType: ''
};

SignatureCancelSurveyModalBodyContent.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  modalType: _propTypes2.default.string
};

var ConnectedSignatureCancelSurveyModalBody = ReactRedux.connect(null, mapDispatchToProps)(SignatureCancelSurveyModalBodyContent);
exports.default = ConnectedSignatureCancelSurveyModalBody;

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignatureReminderModalBodyContent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(83);

var _Button2 = _interopRequireDefault(_Button);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalActions = __webpack_require__(82);

var _SignatureManagerActions = __webpack_require__(140);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _EditorOverlayActions = __webpack_require__(325);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeModal: _ModalActions.closeModal,
    updateSignatureActiveButton: _SignatureManagerActions.updateSignatureActiveButton,
    expandFreeWriteAddSignatureSection: _SignatureManagerActions.expandFreeWriteAddSignatureSection,
    requestFreeWriteExport: _EditorOverlayActions.requestFreeWriteExport
  }, dispatch);
};

var SignatureReminderModalBodyContent = exports.SignatureReminderModalBodyContent = function (_React$Component) {
  _inherits(SignatureReminderModalBodyContent, _React$Component);

  function SignatureReminderModalBodyContent() {
    _classCallCheck(this, SignatureReminderModalBodyContent);

    var _this = _possibleConstructorReturn(this, (SignatureReminderModalBodyContent.__proto__ || Object.getPrototypeOf(SignatureReminderModalBodyContent)).call(this));

    _this.state = {
      response: null,
      cancelReason: '',
      selection: null
    };
    _this.expandSignatureSection = _this.expandSignatureSection.bind(_this);
    _this.continueWithoutSigning = _this.continueWithoutSigning.bind(_this);
    return _this;
  }

  _createClass(SignatureReminderModalBodyContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.localStorage.setItem('signatureAdded', 1);
      window._track('Viewed Signature Reminder', 'My Documents');
    }
  }, {
    key: 'continueWithoutSigning',
    value: function continueWithoutSigning() {
      this.props.closeModal(this.props.modalType);
      this.props.requestFreeWriteExport();
      window._track('Continue Without Signing | Viewed Signature Reminder', 'My Documents');
    }
  }, {
    key: 'expandSignatureSection',
    value: function expandSignatureSection() {
      this.props.closeModal(this.props.modalType);
      this.props.expandFreeWriteAddSignatureSection('type');
      window._track('Sign Now | Viewed Signature Reminder', 'My Documents');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'signature-reminder' },
        _react2.default.createElement('button', { className: 'modal-close-btn', onClick: this.continueWithoutSigning }),
        _react2.default.createElement('img', { className: 'signature-reminder-image', src: window.cdnUrl + '/images/signature-reminder/signature-reminder-2x.png', alt: 'Signature' }),
        _react2.default.createElement(
          'h4',
          null,
          'Do you need to sign this document?'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Type, draw or add a signature to make your document official.'
        ),
        _react2.default.createElement(
          'div',
          { className: 'buttons' },
          _react2.default.createElement(_Button2.default, {
            buttonOnClick: this.expandSignatureSection,
            buttonText: 'Sign Now',
            trackCategory: this.state.response,
            trackAction: 'My Documents',
            type: 'submit'
          }),
          _react2.default.createElement(
            'button',
            {
              className: 'continue-without-signing-btn',
              onClick: this.continueWithoutSigning
            },
            'Continue without signing'
          )
        )
      );
    }
  }]);

  return SignatureReminderModalBodyContent;
}(_react2.default.Component);

SignatureReminderModalBodyContent.defaultProps = {
  modalType: ''
};

SignatureReminderModalBodyContent.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  modalType: _propTypes2.default.string,
  expandFreeWriteAddSignatureSection: _propTypes2.default.func.isRequired,
  requestFreeWriteExport: _propTypes2.default.func.isRequired
};

var ConnectedSignatureReminderModalBody = ReactRedux.connect(null, mapDispatchToProps)(SignatureReminderModalBodyContent);
exports.default = ConnectedSignatureReminderModalBody;

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var OfferManager = function OfferManager() {
    var that = this;

    that.showReactivationModal = function () {
        // hide all other modals first, other-wise they might appear on top of the offer

        $(".modal").each(function () {
            $(this).modal("hide");
        });

        $("#reactivation-offer-modal").modal("show");
    };

    that.requestExport = function (afterSuccessFunc, upgradeUrl, checkOnly, search) {
        var paramStr = search || window.location.search.substr(1);
        if (checkOnly) {
            paramStr += "&check_only=1";
        }

        if (window.exportURL && window.exportURL.includes('force_download=1')) {
            paramStr += "&force_download=1";
        }
        if (paramStr.indexOf('?') === 0) {
            paramStr = paramStr.substring(1);
        }
        $.post("/_api/requestExport.php", paramStr, function (resp) {
            if (resp.allow_export) {
                afterSuccessFunc();
            } else {
                if (resp.next_action == 'show_reactivation_modal') {
                    that.showReactivationModal();
                } else {
                    window.location = upgradeUrl;
                }
            }
        });
    };

    that.applyReactivationOffer = function (showOfferOn) {
        $(showOfferOn).each(this.addReactivationOfferClickEvent);
    };

    that.addReactivationOfferClickEvent = function () {

        // We don't want any other onclick events firing, remove them then add our own.
        $(this).prop('onclick', null);
        $(this).attr("href", "#");

        $(this).click(function (e) {
            that.showReactivationModal();
            e.preventDefault();
            return false;
        });
    };
};

module.exports = OfferManager;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
  var onClickHandler = function onClickHandler() {
    if (props.trackCategory && props.trackAction) {
      window._track(props.trackCategory, props.trackAction);
    }
    props.buttonOnClick();
  };

  return _react2.default.createElement(
    'button',
    {
      id: props.id,
      className: props.buttonClass,
      onClick: onClickHandler
    },
    props.buttonText
  );
};

Button.propTypes = {
  buttonOnClick: _propTypes2.default.func,
  buttonText: _propTypes2.default.string,
  buttonClass: _propTypes2.default.string,
  id: _propTypes2.default.string,
  trackCategory: _propTypes2.default.string,
  trackAction: _propTypes2.default.string
};

Button.defaultProps = {
  buttonOnClick: function buttonOnClick() {
    return true;
  },
  buttonClass: 'btn btn-large btn-success',
  buttonText: 'Success',
  id: '',
  trackCategory: null,
  trackAction: null
};

exports.default = Button;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(props) {
  return _react2.default.createElement(
    'div',
    {
      id: props.progressBarId,
      className: props.progressBarClassName,
      style: props.style
    },
    _react2.default.createElement('div', {
      id: props.progressId,
      className: props.progressClassName,
      style: {
        width: props.step * 100 / props.totalSteps + '%'
      }
    })
  );
};

ProgressBar.defaultProps = {
  progressBarId: '',
  progressId: '',
  progressBarClassName: '',
  progressClassName: '',
  style: {}
};

ProgressBar.propTypes = {
  step: _propTypes2.default.number.isRequired,
  totalSteps: _propTypes2.default.number.isRequired,
  style: _propTypes2.default.shape({
    display: _propTypes2.default.string
  }),
  progressBarId: _propTypes2.default.string,
  progressId: _propTypes2.default.string,
  progressBarClassName: _propTypes2.default.string,
  progressClassName: _propTypes2.default.string
};

exports.default = ProgressBar;

/***/ })

},[1313]);


// WEBPACK FOOTER //
// chart.js